import { render } from "./FaqIcon.vue?vue&type=template&id=73a48c4a&scoped=true"
const script = {}

import "./FaqIcon.vue?vue&type=style&index=0&id=73a48c4a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a48c4a"]])

export default __exports__